import { PRODUCT_NAME } from "@mailhand/core/brand";
import type { ActionMode, ActionType, FollowUpState, InputSource, InputType, MessageState, RunState } from "@mailhand/core/schemas";
import type { Tone } from "../ui/index.js";

export const MESSAGE_STATE_LABEL: Record<MessageState, { label: string; tone: Tone }> = {
  received: { label: "Received", tone: "blue" },
  setup: { label: "Setup", tone: "grey" },
  ignored: { label: "Ignored", tone: "grey" },
  held: { label: "Held", tone: "orange" },
  waiting: { label: "Waiting", tone: "amber" },
  running: { label: "Running", tone: "blue" },
  done: { label: "Done", tone: "green" },
};

export const FOLLOW_UP_LABEL: Record<Exclude<FollowUpState, "none">, { label: string; tone: Tone }> = {
  open: { label: "Follow-up", tone: "blue" },
  closed: { label: "Follow-up closed", tone: "grey" },
};

export const RUN_STATE_LABEL: Record<RunState, { label: string; tone: Tone }> = {
  awaiting_approval: { label: "Waiting for you", tone: "amber" },
  queued: { label: "Queued", tone: "blue" },
  succeeded: { label: "Succeeded", tone: "green" },
  rejected: { label: "Rejected", tone: "orange" },
  failed: { label: "Failed", tone: "orange" },
  held: { label: "Held", tone: "orange" },
  superseded: { label: "Set aside", tone: "grey" },
};

export const ACTION_TYPE_LABEL: Record<ActionType, string> = {
  reply: "Reply",
  forward: "Forward",
  webhook: "Webhook",
  hold: "Hold",
  ignore: "Ignore",
};

export const ACTION_MODE_LABEL: Record<ActionMode, string> = {
  auto: "Auto",
  approve: "Needs approval",
};

export const INPUT_SOURCE_LABEL: Record<InputSource, string> = {
  extract: "Found in the email",
  compose: `Written by ${PRODUCT_NAME}`,
  constant: "Fixed value",
  template: "Template",
};

export const INPUT_TYPE_LABEL: Record<InputType, string> = {
  string: "Short text",
  text: "Long text",
  number: "Number",
  boolean: "Yes / no",
  email: "Email",
};
